import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@infrastructure/shared/theme/loader/loader.service';
import { DatesService } from 'app/infrastructure/services/alpura/dates.service';
import { ReversaLiquidacionService } from 'app/infrastructure/services/captura/reversa-liquidacion.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-reversa-liquidacion',
  templateUrl: './reversa-liquidacion.component.html',
  styleUrls: ['./reversa-liquidacion.component.scss']
})

export class ReversaLiquidacionComponent implements OnInit {

  public panelInfo: any = {};

  guardarFG: UntypedFormGroup = this.untypedFormBuilder.group({
    idEjercicio: ['', [Validators.required]],
    idSemana: ['', [Validators.required]]
  });
  constructor(
    private untypedFormBuilder: UntypedFormBuilder,
    private _datesService: DatesService,
    private http: HttpClient,
    private loader: LoaderService,
    private servicioReversa: ReversaLiquidacionService
    ) {
      this.setDates();
     }


  ngOnInit(): void {
  }

  private setDates() {
    this._datesService.getCurrentDate().subscribe(async (resp: any) => {
      this.panelInfo.currentDate = new Date(resp);
      this.panelInfo.year = (new Date(resp)).getFullYear();
      this._datesService.getCurrentWeek().subscribe(async (resp: any) => {
        this.panelInfo.week = resp;
        const idEjercicioControl = this.guardarFG.get('idEjercicio');
        const idSemanaControl = this.guardarFG.get('idSemana');

        if (idEjercicioControl) {
          idEjercicioControl.setValue(this.panelInfo.year);
        }

        if (idSemanaControl) {
          idSemanaControl.setValue(this.panelInfo.week);
        }
        let paramsInicio = this.panelInfo.year + "/" + this.panelInfo.week + "/" + "I";
        let paramsFin = this.panelInfo.year + "/" + (this.panelInfo.week) + "/" + "F";
        this._datesService.getFechaByWeek(paramsInicio).subscribe(
          response => {
            let fecha = new Date(response);
            fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());
            this.panelInfo.diaInicio = new Date(fecha);
          },
          error => {
          }
        );
        this._datesService.getFechaByWeek(paramsFin).subscribe(
          response => {
            let fecha = new Date(response);
            fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());

            this.panelInfo.diaFin = new Date(fecha);
          },
          error => {
          }
        );
      },
        error => {
        });
    },
      error => {
      });

  }

  onReversaClick(): void {
    if (this.guardarFG.valid) {
      const ejercicio = this.guardarFG.get('idEjercicio')?.value;
      const semana = this.guardarFG.get('idSemana')?.value;

      const payload = {
        "ejercicio": ejercicio,
        "semana": +semana
      };

      this.loader.setLoading(true, "Reversando...");
      this.servicioReversa.reversaLiquidacion(payload).subscribe(
        (response: any) => {
          this.loader.setLoading(false);
          if (response.code === "200") {
            Swal.fire({
              icon: 'success',
              title: 'Exito',
              html: `<br><br><em class='fa fa-info-circle'></em>&nbsp; ${response.message || 'La operación se ha completado con éxito'}`,
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              html: `<br><br><em class='fa fa-info-circle'></em>&nbsp; ${response.message || 'Ocurrió un error inesperado'}`,
            });
          }
        },
        error => {
          this.loader.setLoading(false);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            html: `<br><br><em class='fa fa-info-circle'></em>&nbsp; ${error.error?.message || 'No se puede realizar la operación'}`,
          });
        }
      );
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Datos incompletos',
        html: `<br><br><em class='fa fa-info-circle'></em>&nbsp; Por favor, completa todos los campos requeridos.`,
      });
    }
  }



}
